import { render, staticRenderFns } from "./InnerPlanking2.vue?vue&type=template&id=bf5e8048&"
import script from "./InnerPlanking2.vue?vue&type=script&lang=js&"
export * from "./InnerPlanking2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports